import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { HYDRATE } from 'next-redux-wrapper';
import { BASE_URL } from '@/constants';
import { CryptoType } from '@/hooks/useGetCrypto';
import tablePrice from '../../public/json/fetchData/tablePrice.json';
import drawerMenu from '../../public/json/fetchData/drawerMenu.json';

const generateSymbols = (symbols: string[]) => {
  return `/market/conf/v2/list${
    symbols && symbols.length > 0
      ? '?' + symbols.map((symbol, index) => `symbols=${symbol}`).join('&')
      : ''
  }`;
};

export const cryptoApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers: any) => {
      return headers;
    }
  }),
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath];
    }
  },
  tagTypes: [],
  endpoints: builder => ({
    getTablePrice: builder.query<{ data: CryptoType[] }, void>({
      query: () => generateSymbols(Object.keys(tablePrice))
    }),
    getDrawerMenu: builder.query<{ data: CryptoType[] }, void>({
      query: () => generateSymbols(drawerMenu)
    }),
    getCurrentList: builder.query<{ data: CryptoType[] }, string[]>({
      query: symbols => generateSymbols(symbols)
    }),
    getSidebarList: builder.query<{ data: CryptoType[] }, string[]>({
      query: symbols => generateSymbols(symbols)
    }),
    getMarketInfo: builder.query<
      { data: any },
      { base: string; quote: string }
    >({
      query: query =>
        `/market/provider/marketlist?base=${query.base}&quote=${
          query.base.toLowerCase() === 'usdt' ? 'TMN' : query.quote
        }`
    }),
    getAllMarketInfo: builder.query<{ data: any }, void>({
      query: () => `/market/provider/marketlist`
    }),
    getCryptoList: builder.query<{ data: CryptoType[] }, string[]>({
      query: symbols => generateSymbols(symbols)
    })
  })
});

// Export hooks for usage in functional components
export const {
  useGetAllMarketInfoQuery,
  useGetSidebarListQuery,
  useGetCurrentListQuery,
  useGetDrawerMenuQuery,
  useGetTablePriceQuery,
  useGetCryptoListQuery,
  useGetMarketInfoQuery,
  util: { getRunningQueriesThunk }
} = cryptoApi;

// export endpoints for use in SSR
export const {
  getAllMarketInfo,
  getCryptoList,
  getTablePrice,
  getDrawerMenu,
  getSidebarList,
  getCurrentList,
  getMarketInfo
} = cryptoApi.endpoints;
